import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { SiteDetailsComponent } from './site-details/site-details.component';
import { SiteDetailsBannerComponent } from './site-details-banner/site-details-banner.component';
import { WeatherForecastComponent } from './weather-forecast/weather-forecast.component';
import { TideForecastComponent } from './tide-forecast/tide-forecast.component';
import { RainfallForecastComponent } from './rainfall-forecast/rainfall-forecast.component';
import { WindForecastComponent } from './wind-forecast/wind-forecast.component';
import { SwellForecastComponent } from './swell-forecast/swell-forecast.component';
import { AboutSiteComponent } from './about-site/about-site.component';
import { SiteAmenityComponent } from './site-amenity/site-amenity.component';
import { ForecastWidgetComponent } from './forecast-widget/forecast-widget.component';
import { SiteAmenitiesWidgetComponent } from './site-amenities-widget/site-amenities-widget.component';
import { SiteTrendsComponent } from './site-trends/site-trends.component';
import { SiteContentWidgetComponent } from './site-content-widget/site-content-widget.component';
import { ChartJSModule } from '../shared/chart-js/chart-js.module';
import { SiteRainfallStatisticsComponent } from './site-rainfall-statistics/site-rainfall-statistics.component';
import { SiteAnnualGradeStatisticsComponent } from './site-annual-grade-statistics/site-annual-grade-statistics.component';
import { SiteWaterTemperatureStatisticsComponent } from './site-water-temperature-statistics/site-water-temperature-statistics.component';
import { WaterQualityForecastComponent } from './water-quality-forecast/water-quality-forecast.component';
import { LastUpdatedWidgetComponent } from '../shared/last-updated-widget/last-updated-widget.component';
import { SiteAlertComponent } from './site-alert/site-alert.component';
import { GoogleChartsModule } from '../shared/google-charts/google-charts.module';
import { NearbySitesComponent } from './nearby-sites/nearby-sites.component';
import { NearbySiteWidgetComponent } from './nearby-site-widget/nearby-site-widget.component';
import { RouterModule } from '@angular/router';
import {MatExpansionModule} from '@angular/material/expansion';
import { IteratorDirective } from '../shared/directives/iterator/iterator.directive';
import { SharedCompsModule } from '../shared/shared-comps.module';

@NgModule({
	declarations: [			
		SiteDetailsComponent, 
		SiteDetailsBannerComponent, 
		WeatherForecastComponent,
		TideForecastComponent,
		RainfallForecastComponent,
		WindForecastComponent,
		SwellForecastComponent,
		AboutSiteComponent,
		SiteAmenityComponent,
		ForecastWidgetComponent,
		SiteAmenitiesWidgetComponent,
		SiteTrendsComponent,
		SiteContentWidgetComponent,
  		SiteRainfallStatisticsComponent,
    	SiteAnnualGradeStatisticsComponent,
    	SiteWaterTemperatureStatisticsComponent,
     	WaterQualityForecastComponent,		
		SiteAlertComponent,
		NearbySitesComponent,
		NearbySiteWidgetComponent				
	],
	imports: [
		CommonModule,
		RouterModule,	
		SharedCompsModule,	
		HttpClientModule,
		HttpClientJsonpModule,		
		ChartJSModule,
		GoogleChartsModule,		
		MatExpansionModule,		
		IteratorDirective
	],
	exports: [SiteDetailsComponent]	
})
export class SiteDetailsModule {}
